import { InjectionToken } from '@angular/core';

export interface IConfig {
  domain: string;
  tokenName: string;
}

export const TOKEN_CONFIG_TOKEN = new InjectionToken<IConfig>('config');
